export default function Mission() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#B8985F]/40 bg-[#B8985F]/10 mb-6">
              <i className="ri-rocket-line text-[#B8985F] text-sm w-4 h-4 flex items-center justify-center"></i>
              <span className="text-[13px] text-[#B8985F] font-medium">Our Mission</span>
            </div>
            <h2 className="text-[36px] md:text-[42px] font-bold text-black leading-[1.2] mb-6">
              Empowering Support Teams with AI
            </h2>
            <p className="text-[16px] md:text-[18px] text-[#555] leading-[1.7] mb-5">
              At EasyMarketPro, we believe customer support shouldn't be a bottleneck. Our mission is to help businesses scale their support operations without increasing headcount, using intelligent AI agents that work seamlessly with human teams.
            </p>
            <p className="text-[16px] md:text-[18px] text-[#555] leading-[1.7]">
              We're not replacing support teams—we're augmenting them. Our AI agents handle repetitive inquiries, allowing your team to focus on complex issues that require human empathy and creativity.
            </p>
          </div>

          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20customer%20support%20representative%20smiling%20while%20working%20with%20AI%20dashboard%20interface%20on%20modern%20computer%20screen%2C%20warm%20office%20lighting%2C%20contemporary%20workspace%20with%20plants%20and%20natural%20elements%2C%20person%20wearing%20business%20casual%20attire%20using%20headset%2C%20collaborative%20human%20and%20AI%20technology%20concept%2C%20clean%20organized%20desk%20setup%2C%20soft%20focus%20background%2C%20professional%20corporate%20photography%20with%20natural%20warm%20tones&width=800&height=900&seq=mission-support-ai-01&orientation=portrait"
              alt="AI-Powered Customer Support"
              title="EasyMarketPro Mission - Human and AI Collaboration"
              className="w-full h-[500px] object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
